// import { WEBSERVER } from './Webserver.js';
// import { PORT } from './Port.js';
import { API } from './API.js';

import axios from 'axios';

// const url = WEBSERVER + ':3000/api/bottles/';
// const url = WEBSERVER + ':' + PORT + '/api/bottles/';
const url = API + '/bottles/';

const debug = false;

class Bottles {
    // get all bottles
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(entry=> ({
                        ...entry,
                        name: entry.name
                    }))
                );
                if (debug) console.log("data = " + data)
            } catch(err) {
                reject(err);
            }

        })
    }

    // get one bottle by id
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                //if (debug) console.log('Bottles.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                console.log('Bottles.getone: ',error)
            })
    }

    // get multiple bottles by ids
    static getmany(ids) {
        if (!ids || ids.length === 0) return Promise.resolve([])

        return axios.post(`${url}by_ids`, { ids })
            .then(response => {
                if (debug) console.log('Bottles.getmany: ', response.data)
                return response.data
            })
            .catch(error => {
                console.log('Bottles.getmany ERROR: ', error)
                return []
            })
    }

    // create entry
    static create(postdata) {
        if (debug) console.log('Bottles.create - url: ',url)
        if (debug) console.log('Bottles.create - postdata: ',postdata)
        return axios.post(url, postdata)
            .then(response => {
                if (debug) console.log('Bottles.create: ',response)
                return response.data._id
            })
            .catch(error => {
                console.log('Bottles.create: ',error)
            })
    }

    static update(id,postdata) {
        if (debug) console.log('Bottles.update: id=',id)
        if (debug) console.log('Bottles.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                if (debug) console.log('Bottles.update: ',response)
                return id
            })
            .catch(error => {
                console.log('Bottles.update: ',error)
            })
    }

    // delete entry
    static delete(id) {
        return axios.delete(`${url}${id}`)
    } 
}

export default Bottles